<template>
  <v-container fluid class="pa-0 ma-0">
    <PageHeader> IT & NETWORK SERVICES </PageHeader>
    <v-row align="center" class="pb-0 pt-15">
      <v-col align="center">
        <h1 style="font-family: Tahoma !important" class="Black">
          Taking IT to Another Level
        </h1>
        <hr />
      </v-col>
    </v-row>
    <v-row align="center" class="pt-0 pb-16 pr-16 pl-16">
      <v-col align="center">
        <p style="font-weight: 400; font-family: Raleway; font-style: normal">
          When you outsource your IT service needs with 3545, we form a
          partnership with you to guide you in choosing & implementing the best
          IT solutions for your needs. Our team understands your hardware and
          network infrastructure and how to optimize and to best leverage your
          software applications.<br /><br />
          We can design and maintain network systems, provide recommendations on
          systems, utilities, and help you choose the software best suited for
          your business. We can evaluate business-critical systems and configure
          them for maximum reliability and efficiency. We also specialize in the
          installation of security, backup, and fail-over systems to minimize
          downtime.
        </p>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col
        align="center"
        cols="12"
        s="12"
        xs="12"
        lg="12"
        xl="12"
        md="12"
        v-for="(item, index) in consulting_details"
        :key="index"
      >
        <v-row class="px-16">
          <v-col v-html="item.icon"></v-col>
          <v-col align="left">
            <v-container class="" style="padding-right: 5em; padding-left: 5em">
              <div class="text-h4 text-wrap Hdrstyle text-left">
                {{ item.title }}
              </div>
              <hr />
              <div class="contentStyle">{{ item.content }}</div>
              <div><hoveredList class="listStyle" :items="item.list" /></div>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="contactDiv px-16" align="center">
      <v-col
        align="center"
        class="vcolRight"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <span class="" style="">
          Get in touch with us today to ask more about our services.</span
        >
      </v-col>

      <v-col
        align="center"
        class="vcolLeft pr-16"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <v-btn class="" outlined color="white"> CONTACT US</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>



<style scoped lang="scss">
.consult {
  padding-left: -15px;
  padding-right: -15px;
}
h1,
h2 {
  font-family: Tahoma !important;
}
hr {
  border-top: 2px solid #a81e2d;
  width: 60px;
  margin-top: 20px;
}
.container_background {
  background-color: #f9f9f9 !important;
}

.v-card {
  background-color: #f9f9f9 !important;
  margin-top: 20px;
  align-items: left;
}

.Hdrstyle {
  font-family: Poppins;
  letter-spacing: 0;
  color: #222;
  font-style: italic;
  font-weight: 700;
  margin-bottom: 24px;
}
.contentStyle {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  padding-top: 20px;
  font-size: 15px;
  line-height: 25px;
  color: #222;
}
.listStyle {
  color: #3d3935;
  font-size: 16px;
  line-height: 18px;
  font-family: open_sansregular;
  margin-bottom: 10px;
}
.contactDiv {
  font-size: 26px;
  color: white;
  font-family: Tahoma, "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 150px;
  background: #a81e2d;
}
</style>

<script>
import HoveredList from "@/components/global/compnentsMixins/HoveredList.vue";
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
export default {
  components: { HoveredList, PageHeader },
  data() {
    return {
      consulting_details: [
        {
          icon: '<img src="../img/icons/services-cloud-red-450x300.png" alt="services-cloud-red" width="450" height="300" style="vertical-align:middle;margin:0px 50px">',
          title: "Cloud Services",
          content:
            "Whether it’s selecting a cloud storage provider, finding a cloud application, developing your network in the cloud we can help. Our experience with cloud service licensing, software-as-a-service, and hosted cloud infrastructures will help you stay above the competition. Many clients just want to know their options – good and bad – so they can make a decision. We give you the information, and you decide.",
          list: [],
        },
        {
          icon: '<img src="../img/icons/services-managedservice-red-450x300.png" alt="services-managedservice-red" width="450" height="300" style="vertical-align:middle;margin:0px 50px">',
          title: "Customizable Managed Service Plan & Hourly Services",
          content:
            "Our goal is to keep your business running efficiently within your budget. Unlike the others, we like to work for our managed service clients. We want to fix issues before you know you have them, and whenever possible – just prevent them from happening. For our hourly clients, we are there when you need us.",
          list: [
            "Protect, monitor, and remove computer viruses, malware, and spyware",
            "Monitor server utilization and configuration• Provide support remotely or on-site",
            "Perform system troubleshooting",
            "Administer network infrastructure",
            "Manage virtualization with Hyper-V or VMware",
            "Monitor backups and perform data recovery",
            "Perform operating system and application updates and patches",
            "Monitor and update network hardware and firmware",
            "Review and report network infrastructure annually",
          ],
        },
        {
          icon: '<img src="../img/icons/services-it-red-450x300.png" alt="services-it-red" width="450" height="300" style="vertical-align:middle;margin:0px 50px">',
          title: "IT Consulting",
          content:
            "3545 can help you navigate the world of IT and figure it out. If it’s time to move to “The Cloud” – we can take you there. Or maybe you just need to stay in touch with your own network when you are in or out of the office. Do you have a mixture of MAC devices, a complex phone system or a Network Infrastructure in need of help? Call us – we can make sense out of all of it with your budget in mind. Our team can help you! Contact us today and set a consulting appointment with our experts.",
          list: [],
        },
      ],
    };
  },
};
</script>

